import * as React from "react";
import { useNavigate, useLocation } from 'react-router-dom';

import { useSelector } from "../../../../store";
import { Box, Typography, Checkbox, FormControlLabel } from "@mui/material";

import RedirectButton from "../../../ui-components/Buttons/RedirectButton";

export default function MobileDeclaration() {
    const location = useLocation();
    const navigate = useNavigate();
	const [confirmDeclaration, setConfirmDeclaration] = React.useState(false);
	const learner = useSelector((state) => state.learner?.details || {});
    const publicUrl = process.env.PUBLIC_URL;
	const fullName = `${learner?.name?.first || ""} ${
		learner?.name?.last || ""
	}`.toUpperCase();

	const handleConfirmDeclaration = async () => {
         navigate(`${publicUrl}/instructions${location?.search || ''}`);
	};
	return (
		<React.Fragment>
			<Box
				sx={{
					bgcolor: "white",
					height: "100%",
					width: { xs: "100%", sm: "calc(100% - 4px)" },
					p: 3,
					overflow: "auto",
					borderRadius: "18px 18px 0px 0px",
				}}
			>
				<Typography
					variant="h6_bold"
					sx={{
						display: "flex",
						justifyContent: "center",
						mt: 1,
						color: "#06b6ad",
					}}
				>
					Declaration of Own Work
				</Typography>
				<Typography variant="h6" sx={{ mt: 2 }}>
					I, <b>{fullName}</b>, declare that the answers I submit to
					the Online Language, Literacy and Numeracy quiz are my own
					work.
				</Typography>
				<Typography variant="h6" sx={{ mt: 2 }}>
					I, <b>{fullName}</b>, will not participate in collusion with
					other individuals and I will take proper and reasonable care
					to ensure that my answers are not copied.
				</Typography>

				<Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
					I, <b>{fullName}</b>, will not impersonate, or allow myself
					to be impersonated by, any person for the purpose of
					completing this assessment.
				</Typography>

				<Typography variant="h6_bold" sx={{ mt: 4 }}>
					Submission
				</Typography>

				<Typography variant="h6" sx={{ mt: 1 }}>
					I, <b>{fullName}</b>, accept that the electronic submission
					of my assessment constitutes my agreement to the above
					Declaration of Own Work.
				</Typography>

				<FormControlLabel
					sx={{ display: "flex", mt: 2, fontSize: "1rem" }}
					control={
						<Checkbox
							onChange={(e) => {
								setConfirmDeclaration(e.target.checked);
							}}
						/>
					}
					label={
						<Typography variant="h6_bold">
							I have read & confirm the above statements.
						</Typography>
					}
				/>

				<RedirectButton
					// url="/question"
					handleClick={handleConfirmDeclaration}
					title="NEXT"
					disabled={!confirmDeclaration}
				/>
			</Box>
		</React.Fragment>
	);
}